type OpenHandler = (prefillMessage?: string, autoSend?: boolean) => void;
let openHandler: OpenHandler | null = null;

export function registerChatbotOpenHandler(handler: OpenHandler) {
  openHandler = handler;
}

export function unregisterChatbotOpenHandler() {
  openHandler = null;
}

/** 챗봇을 그냥 열기 */
export function triggerOpenChatbot() {
  openHandler?.();
}

/**
 * 챗봇을 열고 메시지를 자동으로 채워넣기
 * @param message  입력창에 채울 내용
 * @param autoSend true 이면 챗봇이 열린 뒤 자동 전송까지 수행
 */
export function triggerOpenChatbotWithMessage(message: string, autoSend = true) {
  openHandler?.(message, autoSend);
}